import React, { Component, useEffect, useState, useRef, useMemo} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";


import { withTranslation } from 'react-i18next';
import { compose } from "redux";
import { useAppContext } from "../../../components/context/appContext";


import { IconButton, Button } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReactTableBuilder from "../../../utils/reactTableBuilder";
import { StandardPage, StandardPageTopContent, StandardPageMainContent, MuiCol, MuiRow, PrinterTypes } from "../../../components/layout";
import { MuiSelect, ScannerInput, MuiTextArea, MuiTextField, MuiCheckbox } from '../../../components/inputs';

import PalletView from "./palletView"
import palletApi from "../../../api/palletApi";

function PalletQuarantine(props) {
  const { t } = props;
  const [quarantinedPallets, setQuarantinedPallets] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formValues, setFormValues] = useState();
  const appContext = useAppContext();

  useEffect(()=>{
    palletApi.getQuarantinedPallet().then((res)=>{
      setQuarantinedPallets(res.data);
    }).catch((err)=>{
      console.log(err)
    });
  },[])

  function onFormSave() {

  }

  function onFormClose() {
    setIsFormOpen(false);
  }

  function onFormOpen(row) {
    console.log(row)
    setFormValues(row);
    setIsFormOpen(true);
  }

  const tableColumns =[
    {
      Header: t('pallet_quarantine.pallet_no'),
      accessor: "barcode"
    },
    {
      Header: t('pallet_quarantine.last_update'),
      accessor: "statusDate",
    },
    {
      Header: t('view'),
      accessor: (row, index)=>{
        return (
          <>
            <Button variant="contained" color="primary" aria-label={t("view")} onClick={()=>{onFormOpen(row)}}>
              <VisibilityIcon sx={{ mr: 1 }} />
              {t("view")}
            </Button>
          </>
        );
      },
    }
  ]

  return (
    <>
      <StandardPage
        title={t("pallet_quarantine.title")}
        description={t("pallet_quarantine.title_desc")}
        showPrinterStatus={false}
        printerType = {PrinterTypes.RFID}
      >
        <StandardPageTopContent>

        </StandardPageTopContent>
        <StandardPageMainContent>
          <ReactTableBuilder columns={tableColumns} data={quarantinedPallets ?? []} maxRows={13}/>
        </StandardPageMainContent>
      </StandardPage>
      <PalletView isOpen={isFormOpen} onClose={onFormClose} onSave={onFormSave} values={formValues}/>
    </>
  );
}

PalletQuarantine.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(PalletQuarantine);